!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports["react-toggle-button"] = t(require("react")) : e["react-toggle-button"] = t(e.React);
}(this, function (e) {
  return function (e) {
    function t(r) {
      if (n[r]) return n[r].exports;
      var a = n[r] = {
        exports: {},
        id: r,
        loaded: !1
      };
      return e[r].call(a.exports, a, a.exports, t), a.loaded = !0, a.exports;
    }

    var n = {};
    return t.m = e, t.c = n, t.p = "", t(0);
  }([function (e, t, n) {
    e.exports = n(12);
  }, function (e, t, n) {
    e.exports = n(17)();
  }, function (e, t) {
    "use strict";

    function n(e) {
      var t = {};

      for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = "number" == typeof e[n] ? e[n] : e[n].val);
      }

      return t;
    }

    t.__esModule = !0, t.default = n, e.exports = t.default;
  }, function (t, n) {
    t.exports = e;
  }, function (e, t, n) {
    (function (t) {
      (function () {
        var n, r, a;
        "undefined" != typeof performance && null !== performance && performance.now ? e.exports = function () {
          return performance.now();
        } : "undefined" != typeof t && null !== t && t.hrtime ? (e.exports = function () {
          return (n() - a) / 1e6;
        }, r = t.hrtime, n = function n() {
          var e;
          return e = r(), 1e9 * e[0] + e[1];
        }, a = n()) : Date.now ? (e.exports = function () {
          return Date.now() - a;
        }, a = Date.now()) : (e.exports = function () {
          return new Date().getTime() - a;
        }, a = new Date().getTime());
      }).call(this);
    }).call(t, n(9));
  }, function (e, t, n) {
    (function (t) {
      for (var r = n(19), a = "undefined" == typeof window ? t : window, o = ["moz", "webkit"], i = "AnimationFrame", l = a["request" + i], u = a["cancel" + i] || a["cancelRequest" + i], s = 0; !l && s < o.length; s++) {
        l = a[o[s] + "Request" + i], u = a[o[s] + "Cancel" + i] || a[o[s] + "CancelRequest" + i];
      }

      if (!l || !u) {
        var c = 0,
            f = 0,
            p = [],
            d = 1e3 / 60;
        l = function l(e) {
          if (0 === p.length) {
            var t = r(),
                n = Math.max(0, d - (t - c));
            c = n + t, setTimeout(function () {
              var e = p.slice(0);
              p.length = 0;

              for (var t = 0; t < e.length; t++) {
                if (!e[t].cancelled) try {
                  e[t].callback(c);
                } catch (e) {
                  setTimeout(function () {
                    throw e;
                  }, 0);
                }
              }
            }, Math.round(n));
          }

          return p.push({
            handle: ++f,
            callback: e,
            cancelled: !1
          }), f;
        }, u = function u(e) {
          for (var t = 0; t < p.length; t++) {
            p[t].handle === e && (p[t].cancelled = !0);
          }
        };
      }

      e.exports = function (e) {
        return l.call(a, e);
      }, e.exports.cancel = function () {
        u.apply(a, arguments);
      }, e.exports.polyfill = function (e) {
        e || (e = a), e.requestAnimationFrame = l, e.cancelAnimationFrame = u;
      };
    }).call(t, function () {
      return this;
    }());
  }, function (e, t) {
    "use strict";

    function n(e) {
      var t = {};

      for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = 0);
      }

      return t;
    }

    t.__esModule = !0, t.default = n, e.exports = t.default;
  }, function (e, t) {
    "use strict";

    function n(e, t, n) {
      for (var r in t) {
        if (Object.prototype.hasOwnProperty.call(t, r)) {
          if (0 !== n[r]) return !1;
          var a = "number" == typeof t[r] ? t[r] : t[r].val;
          if (e[r] !== a) return !1;
        }
      }

      return !0;
    }

    t.__esModule = !0, t.default = n, e.exports = t.default;
  }, function (e, t) {
    "use strict";

    function n(e, t, n, a, o, i, l) {
      var u = -o * (t - a),
          s = -i * n,
          c = u + s,
          f = n + c * e,
          p = t + f * e;
      return Math.abs(f) < l && Math.abs(p - a) < l ? (r[0] = a, r[1] = 0, r) : (r[0] = p, r[1] = f, r);
    }

    t.__esModule = !0, t.default = n;
    var r = [0, 0];
    e.exports = t.default;
  }, function (e, t) {
    function n() {
      throw new Error("setTimeout has not been defined");
    }

    function r() {
      throw new Error("clearTimeout has not been defined");
    }

    function a(e) {
      if (c === setTimeout) return setTimeout(e, 0);
      if ((c === n || !c) && setTimeout) return c = setTimeout, setTimeout(e, 0);

      try {
        return c(e, 0);
      } catch (t) {
        try {
          return c.call(null, e, 0);
        } catch (t) {
          return c.call(this, e, 0);
        }
      }
    }

    function o(e) {
      if (f === clearTimeout) return clearTimeout(e);
      if ((f === r || !f) && clearTimeout) return f = clearTimeout, clearTimeout(e);

      try {
        return f(e);
      } catch (t) {
        try {
          return f.call(null, e);
        } catch (t) {
          return f.call(this, e);
        }
      }
    }

    function i() {
      h && d && (h = !1, d.length ? y = d.concat(y) : m = -1, y.length && l());
    }

    function l() {
      if (!h) {
        var e = a(i);
        h = !0;

        for (var t = y.length; t;) {
          for (d = y, y = []; ++m < t;) {
            d && d[m].run();
          }

          m = -1, t = y.length;
        }

        d = null, h = !1, o(e);
      }
    }

    function u(e, t) {
      this.fun = e, this.array = t;
    }

    function s() {}

    var c,
        f,
        p = e.exports = {};
    !function () {
      try {
        c = "function" == typeof setTimeout ? setTimeout : n;
      } catch (e) {
        c = n;
      }

      try {
        f = "function" == typeof clearTimeout ? clearTimeout : r;
      } catch (e) {
        f = r;
      }
    }();
    var d,
        y = [],
        h = !1,
        m = -1;
    p.nextTick = function (e) {
      var t = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
        t[n - 1] = arguments[n];
      }
      y.push(new u(e, t)), 1 !== y.length || h || a(l);
    }, u.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, p.title = "browser", p.browser = !0, p.env = {}, p.argv = [], p.version = "", p.versions = {}, p.on = s, p.addListener = s, p.once = s, p.off = s, p.removeListener = s, p.removeAllListeners = s, p.emit = s, p.prependListener = s, p.prependOnceListener = s, p.listeners = function (e) {
      return [];
    }, p.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, p.cwd = function () {
      return "/";
    }, p.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, p.umask = function () {
      return 0;
    };
  }, function (e, t) {
    "use strict";

    t.__esModule = !0, t.default = {
      noWobble: {
        stiffness: 170,
        damping: 26
      },
      gentle: {
        stiffness: 120,
        damping: 14
      },
      wobbly: {
        stiffness: 180,
        damping: 12
      },
      stiff: {
        stiffness: 210,
        damping: 20
      }
    }, e.exports = t.default;
  }, function (e, t) {
    "use strict";

    function n(e) {
      var t = e;
      if (l[t]) return l[t];
      t = t.replace("#", ""), 3 === t.length && (t = t[0] + t[0] + t[1] + t[1] + t[2] + t[2]);
      var n = t.match(/.{2}/g),
          r = {
        r: parseInt(n[0], 16),
        g: parseInt(n[1], 16),
        b: parseInt(n[2], 16)
      };
      return l[t] = r, r;
    }

    function r(e) {
      var t = e.indexOf("rgb") != -1,
          n = e.indexOf("rgba") != -1,
          r = e.match(/\d+/g);
      if (t && !n) return {
        r: parseInt(r[0]),
        g: parseInt(r[1]),
        b: parseInt(r[2])
      };

      if (t && n) {
        var a = "0" == r[3] ? "0." + r[4] : r[3];
        return {
          r: parseInt(r[0]),
          g: parseInt(r[1]),
          b: parseInt(r[2]),
          a: parseFloat(a)
        };
      }

      return null;
    }

    function a(e, t, n) {
      var r = e.toString(16),
          a = t.toString(16),
          o = n.toString(16);
      return r = r.length < 2 ? "0" + r : r, a = a.length < 2 ? "0" + a : a, o = o.length < 2 ? "0" + o : o, "#" + r + a + o;
    }

    function o(e, t, n, r, a) {
      var o = n - t,
          i = a - r,
          l = (e - t) / o;
      return r + l * i;
    }

    function i(e, t, n, a, i, l) {
      var u = void 0 === a ? 0 : a,
          s = void 0 === i ? 1 : i,
          c = r(t),
          f = r(n),
          p = Math.floor(o(e, u, s, c.r, f.r)),
          d = Math.floor(o(e, u, s, c.g, f.g)),
          y = Math.floor(o(e, u, s, c.b, f.b)),
          h = !1,
          m = null;
      return c.a && f.a && (h = !0, m = o(e, u, s, c.a, f.a)), m ? "rgb(" + p + "," + d + "," + y + "," + m + ")" : "rgb(" + p + "," + d + "," + y + ")";
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.hexToRGB = n, t.rgbToObj = r, t.rgbToHex = a, t.mapValueInRange = o, t.interpolateColor = i;
    var l = {};
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var a = n(13),
        o = r(a);
    e.exports = o.default;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function a(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function o(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function i(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var l = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        u = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        s = n(3),
        c = r(s),
        f = n(24),
        p = n(1),
        d = r(p),
        y = n(14),
        h = n(11),
        m = {
      active: {
        base: "rgb(1,124,66)",
        hover: "rgb(1,124,66)"
      },
      inactive: {
        base: "rgb(65,66,68)",
        hover: "rgb(65,66,68)"
      },
      activeThumb: {
        base: "rgb(250,250,250)",
        hover: "rgb(250,250,250)"
      },
      inactiveThumb: {
        base: "rgb(250,250,250)",
        hover: "rgb(250,250,250)"
      }
    },
        v = {},
        b = function (e) {
      function t(e) {
        a(this, t);
        var n = o(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
        return n.state = {
          isHover: !1
        }, n;
      }

      return i(t, e), u(t, [{
        key: "onMouseOver",
        value: function value() {
          this.setState({
            isHover: !0
          });
        }
      }, {
        key: "onMouseOut",
        value: function value() {
          this.setState({
            isHover: !1
          });
        }
      }, {
        key: "_convertToRgb",
        value: function value(e, t) {
          if (e.indexOf("#") != -1) {
            var n = (0, h.hexToRGB)(e);
            return "rgb(" + n.r + ", " + n.g + ", " + n.b + ")";
          }

          return e.indexOf("rgb") == -1 ? t : e;
        }
      }, {
        key: "checkAllColors",
        value: function value(e) {
          var t = this;
          return Object.keys(e).forEach(function (n) {
            t.checkColors(e, n);
          }), e;
        }
      }, {
        key: "checkColors",
        value: function value(e, t) {
          e[t] ? e[t].hover ? (e[t].base = this._convertToRgb(e[t].base, m[t].base), e[t].hover = this._convertToRgb(e[t].hover, m[t].hover)) : e[t].base ? (e[t].base = this._convertToRgb(e[t].base, m[t].base), e[t].hover = e[t].base) : (console.warn('Color prop should have a "base" style and a "hover" style!'), e[t] = m[t]) : e[t] = m[t];
        }
      }, {
        key: "interpolateColorWithHover",
        value: function value(e, t, n) {
          var r = this.props.colors;
          return this.checkColors(r, t), this.checkColors(r, n), this.state.isHover ? {
            backgroundColor: (0, h.interpolateColor)(e, r[t].hover, r[n].hover, 0, 400)
          } : {
            backgroundColor: (0, h.interpolateColor)(e, r[t].base, r[n].base, 0, 400)
          };
        }
      }, {
        key: "makeStyle",
        value: function value(e, t) {
          return this.state.isHover ? l({}, e, t) : e;
        }
      }, {
        key: "handleClick",
        value: function value(e) {
          e.target !== this._input && (e.preventDefault(), this._input.focus(), this._input.click());
        }
      }, {
        key: "render",
        value: function value() {
          var e = this,
              t = this.props,
              n = t.internalSpringSetting,
              r = t.internalHoverSpringSetting,
              a = t.value,
              o = t.thumbAnimateRange,
              i = (t.isHover, t.containerStyle),
              u = t.trackStyle,
              s = t.animateTrackStyleToggle,
              p = t.animateTrackStyleHover,
              d = t.thumbStyleHover,
              h = t.trackStyleHover,
              m = t.activeLabelStyle,
              v = t.activeLabelStyleHover,
              b = t.activeLabel,
              g = t.inactiveLabelStyle,
              S = t.inactiveLabelStyleHover,
              T = t.inactiveLabel,
              O = t.thumbStyle,
              k = t.animateThumbStyleHover,
              w = t.animateThumbStyleToggle,
              I = t.thumbIcon,
              P = t.onClick,
              j = t.onToggle,
              _ = t.passThroughInputProps,
              x = n,
              M = r;
          return c.default.createElement(f.Motion, {
            style: {
              opacity: (0, f.spring)(a ? 1 : 0, x),
              left: (0, f.spring)(a ? 10 * o[1] : 10 * o[0], x),
              colorNumber: (0, f.spring)(a ? 0 : 400, x),
              toggleNumber: (0, f.spring)(a ? 400 : 0, x),
              hoverNumber: (0, f.spring)(this.state.isHover ? 400 : 0, M)
            }
          }, function (t) {
            var n = t.opacity,
                r = t.left,
                o = t.colorNumber,
                f = t.hoverNumber,
                x = t.toggleNumber;
            return c.default.createElement("div", {
              style: l({}, e.makeStyle(l({}, y.reactToggle, i))),
              onMouseOver: e.onMouseOver.bind(e),
              onMouseOut: e.onMouseOut.bind(e),
              onClick: e.handleClick.bind(e)
            }, c.default.createElement("div", {
              style: l({}, e.makeStyle(l({}, y.reactToggleTrack, u, e.interpolateColorWithHover(o, "active", "inactive"), s(x / 400)), l({}, h, p(f / 400))))
            }, c.default.createElement("div", {
              style: l({}, e.makeStyle(l({}, y.reactToggleOn, m), v), {
                opacity: n
              })
            }, b), c.default.createElement("div", {
              style: l({}, e.makeStyle(l({}, y.reactToggleOff, g), S), {
                opacity: 1 - n
              })
            }, T)), c.default.createElement("div", {
              style: y.reactThumbCenteringContainer
            }, c.default.createElement("div", {
              style: l({}, e.makeStyle(l({}, y.reactToggleThumb, O, e.interpolateColorWithHover(o, "activeThumb", "inactiveThumb"), w(x / 400)), l({}, d, k(f / 400))), {
                position: "relative",
                left: Math.round(r / 10)
              })
            }, I)), c.default.createElement("input", l({
              ref: function ref(t) {
                e._input = t;
              },
              type: "checkbox",
              style: y.reactToggleScreenReaderOnly,
              onClick: function onClick(e) {
                P && P(e), j(a);
              },
              value: a
            }, _)));
          });
        }
      }]), t;
    }(s.Component);

    b.defaultProps = {
      value: !1,
      onToggle: function onToggle() {},
      colors: m,
      passThroughInputProps: {},
      activeLabel: "ON",
      containerStyle: v,
      activeLabelStyle: v,
      activeLabelStyleHover: v,
      inactiveLabel: "OFF",
      inactiveLabelStyle: v,
      inactiveLabelStyleHover: v,
      thumbStyle: v,
      thumbStyleHover: v,
      animateThumbStyleHover: function animateThumbStyleHover() {
        return {};
      },
      animateThumbStyleToggle: function animateThumbStyleToggle() {
        return {};
      },
      trackStyle: v,
      trackStyleHover: v,
      animateTrackStyleHover: function animateTrackStyleHover() {
        return {};
      },
      animateTrackStyleToggle: function animateTrackStyleToggle() {
        return {};
      },
      thumbAnimateRange: [1, 33],
      internalSpringSetting: {
        stiffness: 180,
        damping: 22
      },
      internalHoverSpringSetting: {
        stiffness: 180,
        damping: 20
      }
    }, b.displayName = "Toggle", t.default = b, b.propTypes = {
      value: d.default.bool.isRequired,
      onToggle: d.default.func.isRequired,
      passThroughInputProps: d.default.object,
      onClick: d.default.func,
      colors: d.default.object,
      activeLabel: d.default.oneOfType([d.default.string, d.default.object]),
      containerStyle: d.default.object,
      activeLabelStyle: d.default.object,
      activeLabelStyleHover: d.default.object,
      activeThumbStyle: d.default.object,
      activeThumbStyleHover: d.default.object,
      inactiveLabel: d.default.oneOfType([d.default.string, d.default.object]),
      inactiveLabelStyle: d.default.object,
      inactiveLabelStyleHover: d.default.object,
      thumbStyle: d.default.object,
      thumbStyleHover: d.default.object,
      trackStyle: d.default.object,
      trackStyleHover: d.default.object,
      animateThumbStyleHover: d.default.func,
      animateTrackStyleHover: d.default.func,
      animateTrackStyleToggle: d.default.func,
      animateThumbStyleToggle: d.default.func,
      internalSpringSetting: d.default.object,
      internalHoverSpringSetting: d.default.object,
      thumbIcon: d.default.oneOfType([d.default.string, d.default.object]),
      thumbAnimateRange: d.default.array
    };
  }, function (e, t) {
    "use strict";

    function n(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        a = (t.reactToggle = n({
      display: "flex",
      width: 52,
      alignItems: "center",
      justifyContent: "flex-start",
      position: "relative",
      cursor: "pointer",
      backgroundColor: "transparent",
      border: 0,
      padding: 0,
      WebkitTouchCallout: "none",
      WebkitUserSelect: "none",
      KhtmlUserSelect: "none",
      MozUserSelect: "none",
      msUserSelect: "none",
      userSelect: "none",
      WebkitTapHighlightColor: "rgba(0,0,0,0)"
    }, "WebkitTapHighlightColor", "transparent"), {
      fontSize: 11,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "'Helvetica Neue', Helvetica, sans-serif"
    });

    t.reactToggleScreenReaderOnly = {
      border: 0,
      clip: "rect(0 0 0 0)",
      height: 1,
      margin: -1,
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: 1
    }, t.reactToggleTrack = {
      width: "52px",
      height: "20px",
      padding: 0,
      borderRadius: "26px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }, t.reactToggleOn = r({}, a, {
      position: "relative",
      color: "#FAFAFA",
      marginTop: "auto",
      marginBottom: "auto",
      lineHeight: 0,
      opacity: 0,
      width: 26,
      height: 20,
      left: 4
    }), t.reactToggleOff = r({}, a, {
      position: "relative",
      color: "rgba(255,255,255,0.6)",
      bottom: "0px",
      marginTop: "auto",
      marginBottom: "auto",
      paddingRight: 5,
      lineHeight: 0,
      width: 26,
      height: 20
    }), t.reactToggleThumb = {
      width: "18px",
      height: "18px",
      display: "flex",
      alignSelf: "center",
      boxShadow: "0 0 0 1px rgba(0,0,0,0.3)",
      borderRadius: "50%",
      WebkitBoxSizing: "border-box",
      MozBoxSizing: "border-box",
      boxSizing: "border-box"
    }, t.reactThumbCenteringContainer = {
      position: "absolute",
      height: "100%",
      top: 0,
      left: 0,
      display: "flex",
      flex: 1,
      alignSelf: "stretch",
      alignItems: "center",
      justifyContent: "flex-start"
    };
  }, function (e, t) {
    "use strict";

    function n(e) {
      return function () {
        return e;
      };
    }

    var r = function r() {};

    r.thatReturns = n, r.thatReturnsFalse = n(!1), r.thatReturnsTrue = n(!0), r.thatReturnsNull = n(null), r.thatReturnsThis = function () {
      return this;
    }, r.thatReturnsArgument = function (e) {
      return e;
    }, e.exports = r;
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n, r, o, i, l, u) {
      if (a(t), !e) {
        var s;
        if (void 0 === t) s = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var c = [n, r, o, i, l, u],
              f = 0;
          s = new Error(t.replace(/%s/g, function () {
            return c[f++];
          })), s.name = "Invariant Violation";
        }
        throw s.framesToPop = 1, s;
      }
    }

    var a = function a(e) {};

    e.exports = r;
  }, function (e, t, n) {
    "use strict";

    var r = n(15),
        a = n(16),
        o = n(18);

    e.exports = function () {
      function e(e, t, n, r, i, l) {
        l !== o && a(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t
      };
      return n.checkPropTypes = r, n.PropTypes = n, n;
    };
  }, function (e, t) {
    "use strict";

    var n = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    e.exports = n;
  }, function (e, t, n) {
    (function (t) {
      (function () {
        var n, r, a, o, i, l;
        "undefined" != typeof performance && null !== performance && performance.now ? e.exports = function () {
          return performance.now();
        } : "undefined" != typeof t && null !== t && t.hrtime ? (e.exports = function () {
          return (n() - i) / 1e6;
        }, r = t.hrtime, n = function n() {
          var e;
          return e = r(), 1e9 * e[0] + e[1];
        }, o = n(), l = 1e9 * t.uptime(), i = o - l) : Date.now ? (e.exports = function () {
          return Date.now() - a;
        }, a = Date.now()) : (e.exports = function () {
          return new Date().getTime() - a;
        }, a = new Date().getTime());
      }).call(this);
    }).call(t, n(9));
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function a(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function o(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    t.__esModule = !0;

    var i = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        l = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        u = n(6),
        s = r(u),
        c = n(2),
        f = r(c),
        p = n(8),
        d = r(p),
        y = n(4),
        h = r(y),
        m = n(5),
        v = r(m),
        b = n(7),
        g = r(b),
        S = n(3),
        T = r(S),
        O = n(1),
        k = r(O),
        w = 1e3 / 60,
        I = function (e) {
      function t(n) {
        var r = this;
        a(this, t), e.call(this, n), this.wasAnimating = !1, this.animationID = null, this.prevTime = 0, this.accumulatedTime = 0, this.unreadPropStyle = null, this.clearUnreadPropStyle = function (e) {
          var t = !1,
              n = r.state,
              a = n.currentStyle,
              o = n.currentVelocity,
              l = n.lastIdealStyle,
              u = n.lastIdealVelocity;

          for (var s in e) {
            if (Object.prototype.hasOwnProperty.call(e, s)) {
              var c = e[s];
              "number" == typeof c && (t || (t = !0, a = i({}, a), o = i({}, o), l = i({}, l), u = i({}, u)), a[s] = c, o[s] = 0, l[s] = c, u[s] = 0);
            }
          }

          t && r.setState({
            currentStyle: a,
            currentVelocity: o,
            lastIdealStyle: l,
            lastIdealVelocity: u
          });
        }, this.startAnimationIfNecessary = function () {
          r.animationID = v.default(function (e) {
            var t = r.props.style;
            if (g.default(r.state.currentStyle, t, r.state.currentVelocity)) return r.wasAnimating && r.props.onRest && r.props.onRest(), r.animationID = null, r.wasAnimating = !1, void (r.accumulatedTime = 0);
            r.wasAnimating = !0;
            var n = e || h.default(),
                a = n - r.prevTime;
            if (r.prevTime = n, r.accumulatedTime = r.accumulatedTime + a, r.accumulatedTime > 10 * w && (r.accumulatedTime = 0), 0 === r.accumulatedTime) return r.animationID = null, void r.startAnimationIfNecessary();
            var o = (r.accumulatedTime - Math.floor(r.accumulatedTime / w) * w) / w,
                i = Math.floor(r.accumulatedTime / w),
                l = {},
                u = {},
                s = {},
                c = {};

            for (var f in t) {
              if (Object.prototype.hasOwnProperty.call(t, f)) {
                var p = t[f];
                if ("number" == typeof p) s[f] = p, c[f] = 0, l[f] = p, u[f] = 0;else {
                  for (var y = r.state.lastIdealStyle[f], m = r.state.lastIdealVelocity[f], v = 0; v < i; v++) {
                    var b = d.default(w / 1e3, y, m, p.val, p.stiffness, p.damping, p.precision);
                    y = b[0], m = b[1];
                  }

                  var S = d.default(w / 1e3, y, m, p.val, p.stiffness, p.damping, p.precision),
                      T = S[0],
                      O = S[1];
                  s[f] = y + (T - y) * o, c[f] = m + (O - m) * o, l[f] = y, u[f] = m;
                }
              }
            }

            r.animationID = null, r.accumulatedTime -= i * w, r.setState({
              currentStyle: s,
              currentVelocity: c,
              lastIdealStyle: l,
              lastIdealVelocity: u
            }), r.unreadPropStyle = null, r.startAnimationIfNecessary();
          });
        }, this.state = this.defaultState();
      }

      return o(t, e), l(t, null, [{
        key: "propTypes",
        value: {
          defaultStyle: k.default.objectOf(k.default.number),
          style: k.default.objectOf(k.default.oneOfType([k.default.number, k.default.object])).isRequired,
          children: k.default.func.isRequired,
          onRest: k.default.func
        },
        enumerable: !0
      }]), t.prototype.defaultState = function () {
        var e = this.props,
            t = e.defaultStyle,
            n = e.style,
            r = t || f.default(n),
            a = s.default(r);
        return {
          currentStyle: r,
          currentVelocity: a,
          lastIdealStyle: r,
          lastIdealVelocity: a
        };
      }, t.prototype.componentDidMount = function () {
        this.prevTime = h.default(), this.startAnimationIfNecessary();
      }, t.prototype.componentWillReceiveProps = function (e) {
        null != this.unreadPropStyle && this.clearUnreadPropStyle(this.unreadPropStyle), this.unreadPropStyle = e.style, null == this.animationID && (this.prevTime = h.default(), this.startAnimationIfNecessary());
      }, t.prototype.componentWillUnmount = function () {
        null != this.animationID && (v.default.cancel(this.animationID), this.animationID = null);
      }, t.prototype.render = function () {
        var e = this.props.children(this.state.currentStyle);
        return e && T.default.Children.only(e);
      }, t;
    }(T.default.Component);

    t.default = I, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function a(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function o(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    function i(e, t, n) {
      for (var r = 0; r < e.length; r++) {
        if (!S.default(e[r], t[r], n[r])) return !1;
      }

      return !0;
    }

    t.__esModule = !0;

    var l = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        u = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        s = n(6),
        c = r(s),
        f = n(2),
        p = r(f),
        d = n(8),
        y = r(d),
        h = n(4),
        m = r(h),
        v = n(5),
        b = r(v),
        g = n(7),
        S = r(g),
        T = n(3),
        O = r(T),
        k = n(1),
        w = r(k),
        I = 1e3 / 60,
        P = function (e) {
      function t(n) {
        var r = this;
        a(this, t), e.call(this, n), this.animationID = null, this.prevTime = 0, this.accumulatedTime = 0, this.unreadPropStyles = null, this.clearUnreadPropStyle = function (e) {
          for (var t = r.state, n = t.currentStyles, a = t.currentVelocities, o = t.lastIdealStyles, i = t.lastIdealVelocities, u = !1, s = 0; s < e.length; s++) {
            var c = e[s],
                f = !1;

            for (var p in c) {
              if (Object.prototype.hasOwnProperty.call(c, p)) {
                var d = c[p];
                "number" == typeof d && (f || (f = !0, u = !0, n[s] = l({}, n[s]), a[s] = l({}, a[s]), o[s] = l({}, o[s]), i[s] = l({}, i[s])), n[s][p] = d, a[s][p] = 0, o[s][p] = d, i[s][p] = 0);
              }
            }
          }

          u && r.setState({
            currentStyles: n,
            currentVelocities: a,
            lastIdealStyles: o,
            lastIdealVelocities: i
          });
        }, this.startAnimationIfNecessary = function () {
          r.animationID = b.default(function (e) {
            var t = r.props.styles(r.state.lastIdealStyles);
            if (i(r.state.currentStyles, t, r.state.currentVelocities)) return r.animationID = null, void (r.accumulatedTime = 0);
            var n = e || m.default(),
                a = n - r.prevTime;
            if (r.prevTime = n, r.accumulatedTime = r.accumulatedTime + a, r.accumulatedTime > 10 * I && (r.accumulatedTime = 0), 0 === r.accumulatedTime) return r.animationID = null, void r.startAnimationIfNecessary();

            for (var o = (r.accumulatedTime - Math.floor(r.accumulatedTime / I) * I) / I, l = Math.floor(r.accumulatedTime / I), u = [], s = [], c = [], f = [], p = 0; p < t.length; p++) {
              var d = t[p],
                  h = {},
                  v = {},
                  b = {},
                  g = {};

              for (var S in d) {
                if (Object.prototype.hasOwnProperty.call(d, S)) {
                  var T = d[S];
                  if ("number" == typeof T) h[S] = T, v[S] = 0, b[S] = T, g[S] = 0;else {
                    for (var O = r.state.lastIdealStyles[p][S], k = r.state.lastIdealVelocities[p][S], w = 0; w < l; w++) {
                      var P = y.default(I / 1e3, O, k, T.val, T.stiffness, T.damping, T.precision);
                      O = P[0], k = P[1];
                    }

                    var j = y.default(I / 1e3, O, k, T.val, T.stiffness, T.damping, T.precision),
                        _ = j[0],
                        x = j[1];
                    h[S] = O + (_ - O) * o, v[S] = k + (x - k) * o, b[S] = O, g[S] = k;
                  }
                }
              }

              c[p] = h, f[p] = v, u[p] = b, s[p] = g;
            }

            r.animationID = null, r.accumulatedTime -= l * I, r.setState({
              currentStyles: c,
              currentVelocities: f,
              lastIdealStyles: u,
              lastIdealVelocities: s
            }), r.unreadPropStyles = null, r.startAnimationIfNecessary();
          });
        }, this.state = this.defaultState();
      }

      return o(t, e), u(t, null, [{
        key: "propTypes",
        value: {
          defaultStyles: w.default.arrayOf(w.default.objectOf(w.default.number)),
          styles: w.default.func.isRequired,
          children: w.default.func.isRequired
        },
        enumerable: !0
      }]), t.prototype.defaultState = function () {
        var e = this.props,
            t = e.defaultStyles,
            n = e.styles,
            r = t || n().map(p.default),
            a = r.map(function (e) {
          return c.default(e);
        });
        return {
          currentStyles: r,
          currentVelocities: a,
          lastIdealStyles: r,
          lastIdealVelocities: a
        };
      }, t.prototype.componentDidMount = function () {
        this.prevTime = m.default(), this.startAnimationIfNecessary();
      }, t.prototype.componentWillReceiveProps = function (e) {
        null != this.unreadPropStyles && this.clearUnreadPropStyle(this.unreadPropStyles), this.unreadPropStyles = e.styles(this.state.lastIdealStyles), null == this.animationID && (this.prevTime = m.default(), this.startAnimationIfNecessary());
      }, t.prototype.componentWillUnmount = function () {
        null != this.animationID && (b.default.cancel(this.animationID), this.animationID = null);
      }, t.prototype.render = function () {
        var e = this.props.children(this.state.currentStyles);
        return e && O.default.Children.only(e);
      }, t;
    }(O.default.Component);

    t.default = P, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function a(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function o(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    function i(e, t, n) {
      var r = t;
      return null == r ? e.map(function (e, t) {
        return {
          key: e.key,
          data: e.data,
          style: n[t]
        };
      }) : e.map(function (e, t) {
        for (var a = 0; a < r.length; a++) {
          if (r[a].key === e.key) return {
            key: r[a].key,
            data: r[a].data,
            style: n[t]
          };
        }

        return {
          key: e.key,
          data: e.data,
          style: n[t]
        };
      });
    }

    function l(e, t, n, r) {
      if (r.length !== t.length) return !1;

      for (var a = 0; a < r.length; a++) {
        if (r[a].key !== t[a].key) return !1;
      }

      for (var a = 0; a < r.length; a++) {
        if (!w.default(e[a], t[a].style, n[a])) return !1;
      }

      return !0;
    }

    function u(e, t, n, r, a, o, i, l, u) {
      for (var s = b.default(r, a, function (e, r) {
        var a = t(r);
        return null == a ? (n({
          key: r.key,
          data: r.data
        }), null) : w.default(o[e], a, i[e]) ? (n({
          key: r.key,
          data: r.data
        }), null) : {
          key: r.key,
          data: r.data,
          style: a
        };
      }), c = [], f = [], d = [], y = [], h = 0; h < s.length; h++) {
        for (var m = s[h], v = null, g = 0; g < r.length; g++) {
          if (r[g].key === m.key) {
            v = g;
            break;
          }
        }

        if (null == v) {
          var S = e(m);
          c[h] = S, d[h] = S;
          var T = p.default(m.style);
          f[h] = T, y[h] = T;
        } else c[h] = o[v], d[h] = l[v], f[h] = i[v], y[h] = u[v];
      }

      return [s, c, f, d, y];
    }

    t.__esModule = !0;

    var s = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        c = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        f = n(6),
        p = r(f),
        d = n(2),
        y = r(d),
        h = n(8),
        m = r(h),
        v = n(23),
        b = r(v),
        g = n(4),
        S = r(g),
        T = n(5),
        O = r(T),
        k = n(7),
        w = r(k),
        I = n(3),
        P = r(I),
        j = n(1),
        _ = r(j),
        x = 1e3 / 60,
        M = function (e) {
      function t(n) {
        var r = this;
        a(this, t), e.call(this, n), this.unmounting = !1, this.animationID = null, this.prevTime = 0, this.accumulatedTime = 0, this.unreadPropStyles = null, this.clearUnreadPropStyle = function (e) {
          for (var t = u(r.props.willEnter, r.props.willLeave, r.props.didLeave, r.state.mergedPropsStyles, e, r.state.currentStyles, r.state.currentVelocities, r.state.lastIdealStyles, r.state.lastIdealVelocities), n = t[0], a = t[1], o = t[2], i = t[3], l = t[4], c = 0; c < e.length; c++) {
            var f = e[c].style,
                p = !1;

            for (var d in f) {
              if (Object.prototype.hasOwnProperty.call(f, d)) {
                var y = f[d];
                "number" == typeof y && (p || (p = !0, a[c] = s({}, a[c]), o[c] = s({}, o[c]), i[c] = s({}, i[c]), l[c] = s({}, l[c]), n[c] = {
                  key: n[c].key,
                  data: n[c].data,
                  style: s({}, n[c].style)
                }), a[c][d] = y, o[c][d] = 0, i[c][d] = y, l[c][d] = 0, n[c].style[d] = y);
              }
            }
          }

          r.setState({
            currentStyles: a,
            currentVelocities: o,
            mergedPropsStyles: n,
            lastIdealStyles: i,
            lastIdealVelocities: l
          });
        }, this.startAnimationIfNecessary = function () {
          r.unmounting || (r.animationID = O.default(function (e) {
            if (!r.unmounting) {
              var t = r.props.styles,
                  n = "function" == typeof t ? t(i(r.state.mergedPropsStyles, r.unreadPropStyles, r.state.lastIdealStyles)) : t;
              if (l(r.state.currentStyles, n, r.state.currentVelocities, r.state.mergedPropsStyles)) return r.animationID = null, void (r.accumulatedTime = 0);
              var a = e || S.default(),
                  o = a - r.prevTime;
              if (r.prevTime = a, r.accumulatedTime = r.accumulatedTime + o, r.accumulatedTime > 10 * x && (r.accumulatedTime = 0), 0 === r.accumulatedTime) return r.animationID = null, void r.startAnimationIfNecessary();

              for (var s = (r.accumulatedTime - Math.floor(r.accumulatedTime / x) * x) / x, c = Math.floor(r.accumulatedTime / x), f = u(r.props.willEnter, r.props.willLeave, r.props.didLeave, r.state.mergedPropsStyles, n, r.state.currentStyles, r.state.currentVelocities, r.state.lastIdealStyles, r.state.lastIdealVelocities), p = f[0], d = f[1], y = f[2], h = f[3], v = f[4], b = 0; b < p.length; b++) {
                var g = p[b].style,
                    T = {},
                    O = {},
                    k = {},
                    w = {};

                for (var I in g) {
                  if (Object.prototype.hasOwnProperty.call(g, I)) {
                    var P = g[I];
                    if ("number" == typeof P) T[I] = P, O[I] = 0, k[I] = P, w[I] = 0;else {
                      for (var j = h[b][I], _ = v[b][I], M = 0; M < c; M++) {
                        var R = m.default(x / 1e3, j, _, P.val, P.stiffness, P.damping, P.precision);
                        j = R[0], _ = R[1];
                      }

                      var C = m.default(x / 1e3, j, _, P.val, P.stiffness, P.damping, P.precision),
                          D = C[0],
                          H = C[1];
                      T[I] = j + (D - j) * s, O[I] = _ + (H - _) * s, k[I] = j, w[I] = _;
                    }
                  }
                }

                h[b] = k, v[b] = w, d[b] = T, y[b] = O;
              }

              r.animationID = null, r.accumulatedTime -= c * x, r.setState({
                currentStyles: d,
                currentVelocities: y,
                lastIdealStyles: h,
                lastIdealVelocities: v,
                mergedPropsStyles: p
              }), r.unreadPropStyles = null, r.startAnimationIfNecessary();
            }
          }));
        }, this.state = this.defaultState();
      }

      return o(t, e), c(t, null, [{
        key: "propTypes",
        value: {
          defaultStyles: _.default.arrayOf(_.default.shape({
            key: _.default.string.isRequired,
            data: _.default.any,
            style: _.default.objectOf(_.default.number).isRequired
          })),
          styles: _.default.oneOfType([_.default.func, _.default.arrayOf(_.default.shape({
            key: _.default.string.isRequired,
            data: _.default.any,
            style: _.default.objectOf(_.default.oneOfType([_.default.number, _.default.object])).isRequired
          }))]).isRequired,
          children: _.default.func.isRequired,
          willEnter: _.default.func,
          willLeave: _.default.func,
          didLeave: _.default.func
        },
        enumerable: !0
      }, {
        key: "defaultProps",
        value: {
          willEnter: function willEnter(e) {
            return y.default(e.style);
          },
          willLeave: function willLeave() {
            return null;
          },
          didLeave: function didLeave() {}
        },
        enumerable: !0
      }]), t.prototype.defaultState = function () {
        var e = this.props,
            t = e.defaultStyles,
            n = e.styles,
            r = e.willEnter,
            a = e.willLeave,
            o = e.didLeave,
            i = "function" == typeof n ? n(t) : n,
            l = void 0;
        l = null == t ? i : t.map(function (e) {
          for (var t = 0; t < i.length; t++) {
            if (i[t].key === e.key) return i[t];
          }

          return e;
        });
        var s = null == t ? i.map(function (e) {
          return y.default(e.style);
        }) : t.map(function (e) {
          return y.default(e.style);
        }),
            c = null == t ? i.map(function (e) {
          return p.default(e.style);
        }) : t.map(function (e) {
          return p.default(e.style);
        }),
            f = u(r, a, o, l, i, s, c, s, c),
            d = f[0],
            h = f[1],
            m = f[2],
            v = f[3],
            b = f[4];
        return {
          currentStyles: h,
          currentVelocities: m,
          lastIdealStyles: v,
          lastIdealVelocities: b,
          mergedPropsStyles: d
        };
      }, t.prototype.componentDidMount = function () {
        this.prevTime = S.default(), this.startAnimationIfNecessary();
      }, t.prototype.componentWillReceiveProps = function (e) {
        this.unreadPropStyles && this.clearUnreadPropStyle(this.unreadPropStyles);
        var t = e.styles;
        "function" == typeof t ? this.unreadPropStyles = t(i(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles)) : this.unreadPropStyles = t, null == this.animationID && (this.prevTime = S.default(), this.startAnimationIfNecessary());
      }, t.prototype.componentWillUnmount = function () {
        this.unmounting = !0, null != this.animationID && (O.default.cancel(this.animationID), this.animationID = null);
      }, t.prototype.render = function () {
        var e = i(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles),
            t = this.props.children(e);
        return t && P.default.Children.only(t);
      }, t;
    }(P.default.Component);

    t.default = M, e.exports = t.default;
  }, function (e, t) {
    "use strict";

    function n(e, t, n) {
      for (var r = {}, a = 0; a < e.length; a++) {
        r[e[a].key] = a;
      }

      for (var o = {}, a = 0; a < t.length; a++) {
        o[t[a].key] = a;
      }

      for (var i = [], a = 0; a < t.length; a++) {
        i[a] = t[a];
      }

      for (var a = 0; a < e.length; a++) {
        if (!Object.prototype.hasOwnProperty.call(o, e[a].key)) {
          var l = n(a, e[a]);
          null != l && i.push(l);
        }
      }

      return i.sort(function (e, n) {
        var a = o[e.key],
            i = o[n.key],
            l = r[e.key],
            u = r[n.key];
        if (null != a && null != i) return o[e.key] - o[n.key];
        if (null != l && null != u) return r[e.key] - r[n.key];

        if (null != a) {
          for (var s = 0; s < t.length; s++) {
            var c = t[s].key;

            if (Object.prototype.hasOwnProperty.call(r, c)) {
              if (a < o[c] && u > r[c]) return -1;
              if (a > o[c] && u < r[c]) return 1;
            }
          }

          return 1;
        }

        for (var s = 0; s < t.length; s++) {
          var c = t[s].key;

          if (Object.prototype.hasOwnProperty.call(r, c)) {
            if (i < o[c] && l > r[c]) return 1;
            if (i > o[c] && l < r[c]) return -1;
          }
        }

        return -1;
      });
    }

    t.__esModule = !0, t.default = n, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e.default : e;
    }

    t.__esModule = !0;
    var a = n(20);
    t.Motion = r(a);
    var o = n(21);
    t.StaggeredMotion = r(o);
    var i = n(22);
    t.TransitionMotion = r(i);
    var l = n(26);
    t.spring = r(l);
    var u = n(10);
    t.presets = r(u);
    var s = n(2);
    t.stripStyle = r(s);
    var c = n(25);
    t.reorderKeys = r(c);
  }, function (e, t, n) {
    "use strict";

    function r() {}

    t.__esModule = !0, t.default = r, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function a(e, t) {
      return o({}, u, t, {
        val: e
      });
    }

    t.__esModule = !0;

    var o = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    };

    t.default = a;
    var i = n(10),
        l = r(i),
        u = o({}, l.default.noWobble, {
      precision: .01
    });
    e.exports = t.default;
  }]);
});